// extracted by mini-css-extract-plugin
export default {"header":"ProjectsHeader_header__wtU0t","dashboardTop":"ProjectsHeader_dashboardTop__+R83l"};